import React from 'react';
import { ANSWER_FILTER, DATE_FILTER, CATEGORY_FILTER } from '../constants';

/**
 * FilterBox - Filter panel for prompts and reflections.
 * Extracted from App.js to reduce component size.
 */
function FilterBox({
  hideShared,
  onHideSharedChange,
  searchText,
  onSearchTextChange,
  answerFilter,
  onAnswerFilterChange,
  dateFilterType,
  onDateFilterTypeChange,
  dateFilterSince,
  onDateFilterSinceChange,
  dateFilterFrom,
  onDateFilterFromChange,
  dateFilterTo,
  onDateFilterToChange,
  onReset
}) {
  return (
    <div className="filter-box-wrapper">
      <div className="filter-box">
        <div className="filter-box-columns">
          {/* Left Column - Existing Filters */}
          <div className="filter-column">
            <div className="filter-row">
              <span className="filter-label">Hide Shared</span>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={hideShared}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    onHideSharedChange(isChecked);
                    // If Hide Shared is toggled on and Show is "New Only", switch to "Answered Only"
                    if (isChecked && answerFilter === ANSWER_FILTER.NEW_ONLY) {
                      onAnswerFilterChange(ANSWER_FILTER.ANSWERED_ONLY);
                    }
                  }}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
            <div className="filter-row">
              <label className="filter-label">Search:</label>
              <input
                type="text"
                className="filter-search-input"
                value={searchText}
                onChange={(e) => onSearchTextChange(e.target.value)}
                placeholder="Search... (title:xxx, text:xxx, user:xxx)"
              />
            </div>
            <div className="filter-row">
              <label className="filter-label">Show:</label>
              <select
                className="filter-dropdown"
                value={answerFilter}
                onChange={(e) => onAnswerFilterChange(e.target.value)}
              >
                <option value={ANSWER_FILTER.SHOW_ALL}>Show All</option>
                <option value={ANSWER_FILTER.UNANSWERED_ONLY}>Unanswered Only</option>
                <option value={ANSWER_FILTER.ANSWERED_ONLY}>Answered Only</option>
                <option value={ANSWER_FILTER.NEW_ONLY} disabled={hideShared}>New Only</option>
              </select>
            </div>
          </div>

          {/* Right Column - Date Filters */}
          <div className="filter-column">
            <div className="filter-row">
              <label className="filter-label">Date Filter:</label>
              <select
                className="filter-dropdown"
                value={dateFilterType}
                onChange={(e) => {
                  onDateFilterTypeChange(e.target.value);
                  // Clear date inputs when changing type
                  if (e.target.value === DATE_FILTER.NONE || e.target.value === DATE_FILTER.LAST_WEEK || e.target.value === DATE_FILTER.LAST_MONTH) {
                    onDateFilterSinceChange('');
                    onDateFilterFromChange('');
                    onDateFilterToChange('');
                  }
                }}
              >
                <option value={DATE_FILTER.NONE}>No Date Filter</option>
                <option value={DATE_FILTER.LAST_WEEK}>Last Week</option>
                <option value={DATE_FILTER.LAST_MONTH}>Last Month</option>
                <option value={DATE_FILTER.SINCE}>Since Date...</option>
                <option value={DATE_FILTER.BETWEEN}>Between Dates...</option>
              </select>
            </div>

            {/* Since Date Input */}
            {dateFilterType === DATE_FILTER.SINCE && (
              <div className="filter-row">
                <label className="filter-label">Since:</label>
                <input
                  type="datetime-local"
                  className="filter-date-input"
                  value={dateFilterSince}
                  onChange={(e) => onDateFilterSinceChange(e.target.value)}
                />
              </div>
            )}

            {/* Between Dates Inputs */}
            {dateFilterType === DATE_FILTER.BETWEEN && (
              <>
                <div className="filter-row">
                  <label className="filter-label">From:</label>
                  <input
                    type="datetime-local"
                    className="filter-date-input"
                    value={dateFilterFrom}
                    onChange={(e) => onDateFilterFromChange(e.target.value)}
                  />
                </div>
                <div className="filter-row">
                  <label className="filter-label">To:</label>
                  <input
                    type="datetime-local"
                    className="filter-date-input"
                    value={dateFilterTo}
                    onChange={(e) => onDateFilterToChange(e.target.value)}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="filter-reset-row">
          <button className="filter-reset-btn" onClick={onReset}>
            Reset Filters
          </button>
        </div>
      </div>
    </div>
  );
}

export default FilterBox;
